import * as React from 'react';
import { SVGProps } from 'react';

const FileIconWavSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 33 40" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M31 0H2a2 2 0 0 0-2 2v36a2 2 0 0 0 2 2h29a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Z" />
    <path
      opacity={0.6}
      fillRule="evenodd"
      clipRule="evenodd"
      d="m23 17-10.727 2.143v9.643h-1.637c-.903 0-1.636.72-1.636 1.607S9.733 32 10.636 32h.546c1.205 0 2.182-.96 2.182-2.143v-6.696l8.545-1.607v5.089h-1.636c-.904 0-1.637.72-1.637 1.607 0 .888.733 1.607 1.637 1.607h.545c1.205 0 2.182-.96 2.182-2.143V17Zm-1.09 2.41-8.546 1.608v1.071l8.545-1.607v-1.071Z"
      fill="#fff"
    />
    <path
      d="M11 7h-1v3l1 2h1l.5-1 .5 1h1l1-2V7h-1v3h-1V8h-1v2h-1V7ZM21 7h1v3h1V7h1v3l-1 2h-1l-1-2V7Z"
      fill="#fff"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.66 11.92a.66.66 0 0 0 .29.08h.55v-.7c-.18 0-.31-.023-.39-.07A.267.267 0 0 1 20 11V8.6c0-.56-.14-.967-.42-1.22-.273-.253-.7-.38-1.28-.38h-1.8v1h1.75c.247 0 .433.057.56.17.127.113.19.273.19.48V9h-1.54c-.973 0-1.46.517-1.46 1.55v.1c0 .493.113.843.34 1.05.233.2.603.3 1.11.3h1.34a.73.73 0 0 0 .61-.3c.073.093.16.167.26.22Zm-.74-1.06c-.053.093-.18.14-.38.14H17.5c-.173 0-.3-.04-.38-.12-.071-.071-.111-.18-.119-.326A.583.583 0 0 1 17.6 10H19v.5a.72.72 0 0 1-.08.36Z"
      fill="#fff"
    />
  </svg>
);
export default FileIconWavSizeM;
